import * as React from 'react'

import { IPageAlert } from 'main/util/page'

export interface IPageContext {
  setAlert: (alert: IPageAlert | null) => void
}

export const PageContext = React.createContext<IPageContext>({
  setAlert: () => undefined,
})
